<div class="view-quiz-progress" data-test="quizProgress">
    <span class="text-semibold">Question {{ (index + 1) }}</span>
    <span *ngIf="total > 1"> of {{ total }}</span>
</div>
